import { ErrorHandler, Injectable } from "@angular/core";

import { WindowRefService } from "../services/window-ref.service";

const RELOAD_FLAG = "chunkLoadReloadAttempted";

// A deploy replaces the hashed bundles, so a tab running the previous build 404s on
// the next lazy route it loads. Reloading picks up the current ones.
@Injectable()
export class ChunkLoadErrorHandler extends ErrorHandler {
  constructor(private windowRefService: WindowRefService) {
    super();
  }

  override handleError(error: unknown) {
    if (this.isChunkLoadError(error) && this.claimReloadAttempt()) {
      this.windowRefService.window.location.reload();
      return;
    }

    super.handleError(error);
  }

  private isChunkLoadError(error: unknown): boolean {
    const { name = "", message = "" } =
      (error as { name?: string; message?: string }) ?? {};

    return (
      name === "ChunkLoadError" ||
      /failed to fetch dynamically imported module/i.test(message) ||
      /error loading dynamically imported module/i.test(message) ||
      /loading chunk \S+ failed/i.test(message)
    );
  }

  // Once per tab session: a genuinely missing chunk must not become a reload loop.
  private claimReloadAttempt(): boolean {
    try {
      if (sessionStorage.getItem(RELOAD_FLAG) === "true") {
        return false;
      }

      sessionStorage.setItem(RELOAD_FLAG, "true");

      return true;
    } catch {
      return false;
    }
  }
}
